import { AddToListMenu } from './AddToListMenu';
import { connect } from 'react-redux';
import { listsActions } from 'src/store/modules/lists';
import { IInitialState } from 'src/store/initialState';
import { isLoggedInSel } from 'src/store/modules/signin';

const mapStateToProps = (state: IInitialState) => ({
  isLoggedIn: isLoggedInSel(state)
});
const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  loadLists: () => dispatch(listsActions.getLists())
});

export const pureComponent = AddToListMenu;
export default connect(mapStateToProps, mapDispatchToProps)(AddToListMenu);

interface IDispatchFromProps {
  loadLists: () => void;
}
